import React, { useState } from 'react';

export default function PlayerList({ state, onShowQR, onCheckin, onCheckout, onResendQR, onKick }) {
  const [openMenu, setOpenMenu] = useState(null); // playerId whose menu is open
  if (!state) return null;

  const { players, playerBalances, playerDetails, playerBetAmounts, playerSettlements, phase } = state;

  // Hide checked-out and kicked players
  const activePlayers = players.filter(p => {
    const d = playerDetails?.[p.id];
    return !d?.checkedOut && !p.kicked;
  });

  const toggleMenu = (id) => setOpenMenu(prev => prev === id ? null : id);

  return (
    <div className="player-list">
      <div className="player-list-header">
        <span className="player-list-title">SPIELER ({activePlayers.length})</span>
        <div className="player-list-header-btns">
          {onCheckin && (
            <button className="player-list-checkin-btn" onClick={onCheckin}>
              NEUER SPIELER +
            </button>
          )}
          <button className="player-list-qr-btn" onClick={onShowQR}>QR</button>
        </div>
      </div>

      {activePlayers.length === 0 && (
        <div className="player-list-empty">Warte auf Spieler...</div>
      )}

      {activePlayers.map(p => {
        const details = playerDetails?.[p.id];
        const balance = playerBalances?.[p.id];
        const initial = details?.initialBalance ?? balance;
        const balanceDelta = balance != null && initial != null ? balance - initial : null;
        const isCheckedIn = details?.checkedIn ?? false;
        const betAmount = playerBetAmounts?.[p.id] ?? 0;
        const settlement = playerSettlements?.[p.id];
        const isOpen = openMenu === p.id;

        return (
          <React.Fragment key={p.id}>
            <div
              className={`player-row ${isOpen ? 'player-row-active' : ''}`}
              onClick={() => toggleMenu(p.id)}
            >
              <span className="player-name">{p.name}</span>
              <div className="player-right">
                <span className="player-balance">
                  {balance != null ? balance : '—'}
                  {isCheckedIn && balanceDelta != null && (
                    <span className={`player-profit ${balanceDelta >= 0 ? 'profit-pos' : 'profit-neg'}`}>
                      {' '}({balanceDelta >= 0 ? '+' : ''}{balanceDelta})
                    </span>
                  )}
                </span>

                {(phase === 'betting' || phase === 'spinning') && betAmount > 0 && (
                  <span className="player-bet-amount">{betAmount} gesetzt</span>
                )}

                {phase === 'result' && settlement && (
                  <span className={`player-settlement ${settlement.net >= 0 ? 'settlement-win' : 'settlement-loss'}`}>
                    {settlement.net >= 0 ? '+' : ''}{settlement.net}
                  </span>
                )}

                <span className="player-chevron">{isOpen ? '▲' : '▼'}</span>
              </div>
            </div>

            {isOpen && (
              <div className="player-action-row">
                {isCheckedIn && onResendQR && details?.playerToken && (
                  <button className="player-action-btn" onClick={(e) => { e.stopPropagation(); onResendQR(p.id); setOpenMenu(null); }}>
                    QR ZEIGEN
                  </button>
                )}
                {isCheckedIn && onCheckout && (
                  <button className="player-action-btn player-action-btn-payout" onClick={(e) => { e.stopPropagation(); onCheckout(p.id); setOpenMenu(null); }}>
                    AUSZAHLEN
                  </button>
                )}
                {onKick && (
                  <button className="player-action-btn player-action-btn-kick" onClick={(e) => { e.stopPropagation(); onKick(p.id, p.name); setOpenMenu(null); }}>
                    ENTFERNEN
                  </button>
                )}
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
